// src/components/JobView/Tabs/FilesAndDocsDisplayTab.js
import React from 'react';
import { UploadCloud, FileText, Download } from 'lucide-react';

const FilesAndDocsDisplayTab = ({ jobData, handleFileChange, addDynamicField, uploadProgress = {} }) => {
    
    // GUARDA DE SEGURIDAD #1: Si no hay datos del trabajo, mostramos un estado de carga.
    // Esto previene cualquier intento de renderizado con datos nulos.
    if (!jobData) {
        return <div className="text-center p-8 text-gray-500">Cargando información del trabajo...</div>;
    }

    // GUARDA DE SEGURIDAD #2: Limpiamos el array de 'documents'.
    // Esto elimina cualquier entrada 'null' o 'undefined' que pueda existir en la base de datos
    // para trabajos antiguos, evitando que el .map() falle.
    const documents = (jobData.documents || []).filter(Boolean);

    return (
        <div>
            <div className="flex justify-between items-center mb-4 border-b pb-2">
                <h3 className="text-lg font-bold text-gray-800">Archivos y Documentos Generales</h3>
                <button 
                    onClick={() => addDynamicField('documents')} 
                    className="px-3 py-1.5 bg-indigo-500 text-white text-sm font-semibold rounded-lg shadow-sm hover:bg-indigo-600"
                >
                    Añadir Documento
                </button>
            </div>
            
            <div className="space-y-4">
                {documents.length > 0 ? (
                    documents.map((doc, index) => {
                        // GUARDA DE SEGURIDAD #3: Verificación final por si acaso.
                        if (!doc) return null;

                        return (
                            <div key={index} className="p-4 bg-gray-50 rounded-lg border flex flex-col md:flex-row items-start md:items-center gap-4">
                                <FileText className="text-gray-400 w-8 h-8 flex-shrink-0" />
                                <div className="flex-grow">
                                    {doc.url ? (
                                        <a href={doc.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-semibold flex items-center gap-2">
                                            {doc.name || 'Archivo sin nombre'} <Download size={14} />
                                        </a>
                                    ) : (
                                        <p className="font-semibold text-gray-700">{doc.name || 'Subiendo archivo...'}</p>
                                    )}
                                    <input
                                        type="text"
                                        name="description"
                                        placeholder="Añadir descripción..."
                                        defaultValue={doc.description || ''}
                                        className="w-full text-sm p-1 mt-1 bg-transparent border-b"
                                    />
                                </div>
                                {!doc.url && (
                                    <div className="w-full md:w-3/5">
                                        <label className="flex items-center justify-center w-full px-2 py-1 border-2 border-dashed rounded-md cursor-pointer hover:border-indigo-500 bg-white">
                                            <UploadCloud size={16} className="text-gray-500" />
                                            <span className="text-xs text-gray-600 ml-2">Seleccionar archivo</span>
                                            <input type="file" className="hidden" onChange={(e) => handleFileChange(index, e)} />
                                        </label>
                                        {/* GUARDA DE SEGURIDAD #4: Usamos el prop con valor por defecto garantizado. */}
                                        {uploadProgress[`doc_${index}`] && (
                                            <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2">
                                                <div className="bg-blue-600 h-1.5 rounded-full" style={{ width: `${uploadProgress[`doc_${index}`]}%` }}></div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center py-12 bg-gray-50 rounded-lg">
                        <p className="text-gray-500">No hay documentos generales en este trabajo.</p>
                        <p className="text-sm text-gray-400 mt-1">Usa el botón "Añadir Documento" para empezar.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FilesAndDocsDisplayTab;
